import { Component, computed } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CapitalContainer } from '@commons/capital-container/capital-container';
import { CapitalBack } from '@commons/capital-back/capital-back';
import { CapitalCard } from '@commons/capital-card/capital-card';
import { CertificadosService, Certificado } from '@commons/services/certificados.service';

interface CertificadoConPath extends Certificado {
  path: string;
}

interface CertificadosPorCategoria {
  [categoria: string]: CertificadoConPath[];
}

@Component({
  selector: 'app-certificates',
  imports: [CommonModule, CapitalContainer, CapitalBack, CapitalCard],
  templateUrl: './certificates.html',
  styleUrl: './certificates.scss',
})
export class Certificates {
  certificadosPorCategoria = computed(() => {
    const data = this.certificadosService.certificadosSignal();
    const categorias: CertificadosPorCategoria = {};

    for (const certificado of data) {
      const categoria = certificado.category || 'Otros';
      if (!categorias[categoria]) {
        categorias[categoria] = [];
      }
      
      // Construir path desde el índice
      const path = `/certificates/${certificado.index}`;
      
      categorias[categoria].push({
        ...certificado,
        path
      });
    }

    // Ordenar certificados dentro de cada categoría por índice
    for (const categoria of Object.keys(categorias)) {
      categorias[categoria].sort((a, b) => a.index - b.index);
    }

    return categorias;
  });

  categorias = computed(() => Object.keys(this.certificadosPorCategoria()));

  constructor(
    private readonly router: Router,
    private readonly certificadosService: CertificadosService
  ) {}

  selectCertificado(path: string) {
    this.router.navigate([path]);
  }
}
